import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Rosette = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C10.488 2 6 6.487 6 12C6 15.262 7.575 18.163 10 20V29C10 29.55 10.45 30 11 30C11.238 30 11.45 29.925 11.613 29.788L16 26.288L20.375 29.788C20.55 29.925 20.762 30 21 30C21.55 30 22 29.55 22 29V20C24.425 18.175 26 15.275 26 12C26 6.487 21.512 2 16 2ZM16 24C15.775 24 15.562 24.075 15.375 24.225L12 26.925V21.163C13.225 21.701 14.575 22 16 22C17.425 22 18.775 21.7 20 21.163V26.925L16.625 24.225C16.437 24.075 16.225 24 16 24ZM16 20C11.588 20 8 16.413 8 12C8 7.587 11.588 4 16 4C20.412 4 24 7.588 24 12C24 16.412 20.413 20 16 20Z" />
	</svg>
);

export default Rosette;
